<p-toast [baseZIndex]="999999" [life]="3000" />
<p-toast
  [key]="cseNoteReminderToastKey"
  styleClass="cse-note-reminder-toast"
  position="top-right"
  [baseZIndex]="1000000">
  <ng-template #message let-message>
    <div class="cse-note-reminder">
      <div class="cse-note-reminder-copy">
        <span class="cse-note-reminder-title">{{ message.summary }}</span>
        <p>{{ message.detail }}</p>
      </div>
      <button type="button" class="cse-note-reminder-action" (click)="openCseNoteReminder($event)">
        Add note
      </button>
    </div>
  </ng-template>
</p-toast>
@if (isLoading) {
  <div class="global-loader">
    <app-loading-overlay [overlay]="true" [fullHeight]="false"></app-loading-overlay>
  </div>
}

<app-confirmation-popup></app-confirmation-popup>

@if (showLayout) {
  <div class="app-layout" [class.no-sidebar]="!showSidebar">
    @if (showSidebar) {
    <app-sidebar></app-sidebar>
    }
    <div class="app-right-side">
      <app-header></app-header>
      <app-staff-portal-preview-bar></app-staff-portal-preview-bar>
      <main class="app-main">
        <router-outlet></router-outlet>
      </main>
      <app-footer></app-footer>
    </div>
  </div>
} @else {
  <router-outlet></router-outlet>
}
